<template>
   <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title">{{$route.query.type=="edit"?'编辑':'新增'}}权益卡</span>
    </a-card>
  
     <a-card :bordered="false" >
         <a-form ref='ruleForm' :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
           <a-form-item label="权益卡名称" name='card_name'>
              <a-input type="text" maxlength="16" v-model:value="form.card_name" style="width:300px" placeholder="请输入名称"></a-input>
              <span class="m-l-10">（限16个字）</span>
           </a-form-item>
            <a-form-item ref="image" label="权益卡封面" name="cover_image" class="s_po_re">
                 <material :groupType="1" :image="form.cover_image" :max="1" v-on:handlechoose="(data) => {form.cover_image = data;}" v-on:handledel="(data) => {form.cover_image = '';}"/>
                <p class="tips">图片宽高要求1:1比例，建议尺寸为640px*640px以上；大小在500Kb以内</p>
            </a-form-item>
            <a-form-item label="有效期" name='expiry_date' help="修改时间后已领取权益卡的用户不更新对应数据" class="m-t-30">
              <a-input-number :max="99" :min="1" :precision="0" v-model:value="form.expiry_date" style="width:120px" placeholder="请输入有效期"></a-input-number>
              <span class="m-l-10">个月</span>
           </a-form-item>
           <a-form-item label="发货方式" required name='' class="m-t-20">
              <a-radio-group v-model:value="form.delivery_type">
                <a-radio :value="2">门店核销</a-radio>
                <!-- <a-radio :value="1">快递配送</a-radio> -->
              </a-radio-group>
           </a-form-item>
            <a-form-item label="核销方式" required name='' help="生成权益卡后无法修改核销类型">
                 <a-radio-group v-model:value="form.write_type" :disabled="$route.query.type=='edit'">
                     <a-radio  :value="1">不指定门店核销</a-radio>
                     <a-radio  :value="2" class="m-l-40 m-r-5">下单门店核销</a-radio>
                </a-radio-group>
                <a-tooltip placement="right" :overlayStyle="{  'max-width':' 1000px'}">
                    <template #title>
                      <p>1.无指定门店核销：消费者可在品牌下任意门店进行礼品核销;</p>
                      <p>2.下单门店核销：消费者在云店购买权益卡后，只能在下单门店进行礼品核销;</p>
                      <p>3.下单门店核销仅支持云店-权益卡使用，其他方式无法关联权益卡;</p>
                      <p>4.生成权益卡后无法修改核销类型;</p>
                    </template>
                    <ExclamationCircleOutlined  style="fontSize:16px;color:#999"/>
                  </a-tooltip>
            </a-form-item>
             <a-form-item label="核销时间" name='write_time_type' help="生成权益卡后无法修改核销时间" class="m-t-20">
                  <a-radio-group v-model:value="form.write_time_type" :disabled="$route.query.type=='edit'" @change="changeDate">
                     <a-radio  :value="1">全月份可核销</a-radio>
                     <a-radio  :value="2" class="m-l-40 m-r-5">指定日期核销</a-radio>
                  </a-radio-group>
                  <a-tooltip placement="right" :overlayStyle="{  'max-width':' 1000px'}">
                    <template #title>
                     <p>1.全月份可核销：当月内，礼品在任意时间内都可核销;</p>
                     <p>2.指定日期核销：当月礼品只能在设置的日期内进行核销，其他时间点不可进行核销操作;</p>
                     <p>3.生成权益后无法修改核销时间;</p>
                    </template>
                    <ExclamationCircleOutlined  style="fontSize:16px;color:#999"/>
                  </a-tooltip>
                   <!--  -->
                  <a-form-item label="日期类型" name='' class="m-t-10" v-if="form.write_time_type==2">
                        <a-radio-group v-model:value="form.write_time_assign_type" :disabled="$route.query.type=='edit'" @change="changeType">
                            <a-radio  :value="1">按日期点设置</a-radio>
                            <a-radio  :value="2" class="m-l-40 m-r-5">自定义日期</a-radio>
                        </a-radio-group>
                        <template v-if="form.write_time_assign_type==1">
                            <a-input-group compact>
                                <a-input-number v-model:value="form.write_date_point_date" :disabled="$route.query.type=='edit'" :max="31" :min="1" :precision="0" placeholder="核销起始日期" style="width:140px"></a-input-number>
                                <span class="p-t-5 p-l-15 p-r-15">号</span>
                                <a-select  v-model:value="form.write_date_point_date_type" :disabled="$route.query.type=='edit'" style="width:76px" >
                                     <a-select-option :value="1">之前</a-select-option>
                                     <a-select-option :value="2">之后</a-select-option>
                                </a-select>
                                <span class="p-t-5 p-l-15">可进行核销（包含输入日期）</span>
                            </a-input-group>
                        </template>
                         <template v-else>
                             <div>
                                <a-input-group compact >
                                  <a-input-number :disabled="$route.query.type=='edit'"  v-model:value="form.write_custom_start_date" :max="31" :min="1" :precision="0" placeholder="核销起始日期" style="width:140px"></a-input-number>
                                  <span class="m-l-10 p-t-5">号</span>
                                  <span class="m-l-10 p-t-5">——</span>
                                  <a-input-number class="m-l-10" :disabled="$route.query.type=='edit'" :readonly="!form.write_custom_start_date" v-model:value="form.write_custom_end_date" :max="31" :min="form.write_custom_start_date" :precision="0" placeholder="核销结束日期" style="width:140px"></a-input-number>
                                  <span class="m-l-10 p-t-5">号</span>
                                 </a-input-group>
                                 <!-- <a-range-picker v-model:value="form.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" /> -->
                             </div>
                        </template>
                   </a-form-item>
             </a-form-item>
             <a-form-item label="最多拥有张数" name='amount' help="生成权益卡后无法修改" class="m-t-20">
                  <a-radio-group v-model:value="form.have_amount_type" @change="onChangeNumber" :disabled="$route.query.type=='edit'">
                     <a-radio  :value="1">不限数量</a-radio>
                     <a-radio  :value="2" class="m-l-40 m-r-5">
                        <span class="m-r-10">每人最多同时拥有</span>
                        <a-input-number v-model:value="form.amount" :disabled="$route.query.type=='edit'?true:form.have_amount_type==1" :max="99" :min="1" :precision="0" placeholder="输入数量"></a-input-number>
                        <span class="m-l-10">张</span>
                     </a-radio>
                </a-radio-group>
             </a-form-item>
             <a-form-item label="消费者资料收集" required name='' class="m-t-20">
                   <a-radio-group v-model:value="form.collect_type" @change="changeCollect">
                     <a-radio :value="1">不收集</a-radio>
                     <a-radio :value="2" class="m-l-40 m-r-5">收集</a-radio>
                  </a-radio-group>
                   <a-tooltip placement="right" :overlayStyle="{  'max-width':' 1000px'}">
                    <template #title>
                      <p>配置没有完整填写基本信息的消费者，</p>
                      <p>进入权益卡详情页时是否弹出弹窗收集资料，</p>
                      <p>已收集的消费者不弹出收集信息弹窗;</p>
                    </template>
                    <ExclamationCircleOutlined  style="fontSize:16px;color:#999"/>
                  </a-tooltip>
                  <a-form-item v-if="form.collect_type==2">
                      <a-checkbox-group v-model:value="form.collect" :disabled="true">
                        <a-checkbox value="name"><span class="s_c000">姓名</span></a-checkbox><br/>
                        <a-checkbox value="phone"><span class="s_c000">手机号</span></a-checkbox><br/>
                        <a-checkbox value="birthday"><span class="s_c000">生日</span></a-checkbox><br/>
                        <a-checkbox value="gender"><span class="s_c000">性别</span></a-checkbox><br/>
                        <a-checkbox value="region"><span class="s_c000">地区</span></a-checkbox>
                      </a-checkbox-group>
                  </a-form-item>
                 
             </a-form-item>
             <!--  -->
             <a-form-item label="每月礼品">
                <h4>（按自然月发放，修改商品或修改礼品数量后已领取权益卡的用户不更新对应数据）</h4>
                <a-table :loading='listLoading' :columns='columns' :data-source='form.gift_data' rowKey='id' bordered :pagination="false">
                   <template v-slot:gift="{record}">
                        <template v-if="record.goods&&record.goods.length!=0">
                           <template v-for="(item,index) in record.goods" :key="index">
                            <a-popover>
                              <template #content>
                                <p>{{item.name}}</p>
                              </template>
                              <div class="ds-i-b m-r-15">
                                   <img :src="item.image_url?oss+item.image_url:'@/assets/images/normal.png'" style="width:80px;height:80px;border-radius:5px"/>
                              </div>
                            </a-popover>
                           </template>
                        </template>
                       <template v-else>
                         <p>不派发礼品</p>
                       </template>
                  </template>
                  <template v-slot:action="{record}">
                    <a-button type="primary" @click="edit(record)">编辑</a-button>
                  </template>
                </a-table>
             </a-form-item>
             <a-form-item label="权益卡使用规则">
               <quill v-model:value="form.usage_rules" :showImg="false" :content="form.usage_rules?JSON.parse(JSON.stringify(form.usage_rules)):''" :height="200" />
             </a-form-item>
             <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24,offset:3 }">
                <a-button type="primary" @click="submit">保存</a-button>
             </a-form-item>
         </a-form>
     </a-card>

      <a-modal :keyboard="false" title="编辑礼品" v-model:visible="showGift" centered :width='1000' :footer="null" destroyOnClose>
          <giftList :goodsList="monthGoods" @confirm="changeGoods"></giftList>
     </a-modal>
   </a-layout>
</template>

<script>
import config from "@/config";
import { profitAdd,profitEdit,profitDetail } from "@/api/assets";
import giftList from '.././components/gift_list'
import { ExclamationCircleOutlined,LeftOutlined } from '@ant-design/icons-vue'
import { reactive, toRefs,ref, onMounted,inject } from 'vue'
 import { message } from "ant-design-vue";
import { iscode } from '../../../../utils/app';
 const oss = config.oss[process.env.VUE_APP_type];
const formData = {
        card_name:'',
        cover_image:'',
        expiry_date:'',
        delivery_type:2,
        write_type:1,
        write_time_type:1,
        write_time_assign_type:1,
        write_date_point_date:'',
        write_date_point_date_type:1,
        time:[],
        write_custom_start_date:'',
        write_custom_end_date:'',
        have_amount_type:1,
        amount:'',
        collect_type:1,
        collect:['name','phone','birthday','gender','region'],
        usage_rules:'',
        gift_data:[
           {
             month:'',
             goods:[]
           }
        ]
    }

const columns = [
  {
    title: "自然月",
    dataIndex: "month",
    width:120,
    align:'center'
  },
  {
    title: "礼品信息",
    dataIndex: "goods",
    slots: { customRender: "gift" },
  },
  {
    title: "礼品总数",
    dataIndex: "number",
     width:120,
     align:'center',
     customRender:({record})=>{
         return record.total_number || 0
     }
  },
  {
    title: "操作",
    dataIndex: "action",
     width:120,
     align:'center',
    slots: { customRender: "action" },
  },
]
export default{
    components:{ExclamationCircleOutlined,LeftOutlined,giftList},
    setup(){
      const $route = inject("$route");
      const $router = inject("$router");
        const form = ref({...formData})
        const ruleForm = ref()
        const state =  reactive({
             monthGoods:{}, //月份商品
             listLoading:false,
             list:[],
             showGift:false,
             rules: {
                    card_name: [{ required: true, message: '请输入权益卡名称！'}],
                    cover_image: [{ required: true, message: '请选择权益卡封面！'}],
                    expiry_date:[{required: true, message: '请输入有效期！'}],
                   amount:[{required: true, validator: async () => {
                                        if (form.value.have_amount_type==2) {
                                          if(!form.value.amount){
                                              return Promise.reject('请输入数量！');
                                          }else{
                                             return Promise.resolve();
                                          }
                                         
                                        } else {
                                          return Promise.resolve();
                                        }
                                      }
                    }],
                    write_time_type:[{ required: true, trigger:'blur',  validator: async () => {
                                        if (form.value.write_time_type==2) {
                                          // return Promise.reject('请输入数量！');
                                            if(form.value.write_time_assign_type==1){
                                               if(!form.value.write_date_point_date){
                                                   return Promise.reject('请输入起始日期！');
                                               }else{
                                                  //  return Promise.resolve();
                                               }
                                            }else{
                                              if(!form.value.write_custom_start_date || !form.value.write_custom_end_date){
                                                  return Promise.reject('请输入时间范围！');
                                               }else{
                                                  // return Promise.resolve();
                                               }
                                            }
                                            
                                        } else {
                                           return Promise.resolve();
                                        }
                                      }
                    }],
              }
        })
        const methods = {
             onChange(e){
                 form.value.time = e;
                 form.value.write_custom_start_date = e[0];
                 form.value.write_custom_end_date = e[0];
             },
             changeType({target}){
                console.log(target)
                if(target.value==1){
                  form.value.time = [];
                  form.value.write_custom_start_date='';
                  form.value.write_custom_end_date='';
                }else{
                   form.value.write_date_point_date = '';
                   form.value.write_date_point_date_type = 1
                }
             },
             changeDate({target}){
               console.log(target)
             },
             onChangeNumber({target}){
                 if(target.value==1){
                    form.value.amount = ''
                 }
             },
             edit(record){
                state.monthGoods = record;
                state.showGift = true;
             },
             submit(){
                ruleForm.value.validate().then(async (res)=>{
                   const hide = message.loading("正在加载中...", 0);
                  let result;

                  if($route.query.type=='add'){
                     result = await profitAdd({...form.value}).then(res=>res.data)
                  }else{
                     result = await profitEdit({...form.value}).then(res=>res.data)
                  }
                  setTimeout(hide);
                  if(iscode(result)){
                      message.success(result.msg);
                      setTimeout(()=>{
                        $router.push('/assets/coupons/memberCard/index')
                      },1000)
                  }else{
                    message.error(result.msg);
                  }
                }).catch((error)=>{
                   message.error('请完善表单！');
                })
             },
             async setGift_data(){
                 if($route.query.type=='edit'){
                   const hide = message.loading("正在加载中...", 0);
                    let result = await profitDetail({id:$route.query.id}).then(res=>res.data);
                    if(iscode(result)){
                      form.value = result.data;
                      form.value.gift_data = result.data.gift_data.map((v,i)=>{
                         return {...v,value:i+1}
                      });
                    }else{
                      message.error(result.msg);
                    }
                    setTimeout(hide);
                 }else{
                       form.value.gift_data = [];
                       for(let i=1;i<13;i++){
                         form.value.gift_data.push({
                            month:i+'月',
                            value:i,
                            goods:[]
                         })
                       }
                 }
               
             },
             changeGoods(data,total){
                let arr = form.value.gift_data;
                for(let i=0;i<arr.length;i++){
                      if(arr[i].value == state.monthGoods.value){
                         arr[i].goods = data;
                         arr[i].total_number = total
                         break;
                    }
                }
                state.showGift = false;
             },
             changeCollect(e){
               if(e.target.value==2){
                  form.value.collect=['name','phone','birthday','gender','region']
               }
             }
        }
        onMounted(()=>{
           methods.setGift_data()

        })
        return {
            form,
            columns,
            ...toRefs(state),
            ...methods,
            ruleForm,
            oss
        }
    }
}
</script>
<style lang="less" scoped>
.tips{
    position: absolute;
    bottom: -15px;
    color: #999;
}

</style>
